import { getContentfulGqlClient } from '@/contentful/wac-content-gql-client.ts';

import { pricingCalculatorContentQuery } from './gql.ts';
import { PricingCalculatorContentResponse } from './types.ts';

export interface GqlClientArgs {
	urlSlug: string;
	locale: string;
}

export type PricingCalculatorContent = PricingCalculatorContentResponse['data'];

export const getPricingCalculatorContent = async (
	args: GqlClientArgs,
): Promise<PricingCalculatorContent | undefined> => {
	const { urlSlug, locale } = args;

	const client = getContentfulGqlClient();

	const result = await client.query<PricingCalculatorContent>(pricingCalculatorContentQuery, {
		urlSlug,
		locale,
	});

	return result.data;
};
